// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Toggle navigation
$('.menu').on('click', function () {
  $('.nav-primary').addClass('active');
});

$('.nav__close').on('click', function () {
  $('.nav-primary').removeClass('active');
});

$('.sub-menu').before().on('click', function() {
  $('.sub-menu').addClass('inactive');
});

$('.nav li a').before().on('click', function() {
  $('.sub-menu').removeClass('inactive');
});

// Login
$('.menu-login').on('click', function() {
  $('.menu-drop').toggleClass('open');
});

$('.banner-login').on('click', function() {
  $('.banner-drop').toggleClass('open');
});

// Search
$('.search-icon').on('click', function() {
  $('.search-overlay').addClass('active');
  $('.search-bar').addClass('active');
});

$('.search-overlay').on('click', function() {
  $('.search-overlay').removeClass('active');
  $('.search-bar').removeClass('active');
});

$(window).on('scroll', function () {
  var scroll = $(window).scrollTop();

  if (scroll >= 60) {
    $('.search-overlay').addClass('scroll');
    $('.search-bar').addClass('scroll');
  } else {
    $('.search-overlay').removeClass('scroll');
    $('.search-bar').removeClass('scroll');
  }

  if(scroll >= 400) {
    $('.go-up').addClass('show');
  } else {
    $('.go-up').removeClass('show');
  }
});

$('.go-up').on('click', function() {
  $('html, body').animate({scrollTop: $('body').offset().top - 150}, 100, 'linear');
});

// Sliders
import Swiper, { Autoplay } from 'swiper';
Swiper.use([Autoplay]);

// Top banner
const banner = new Swiper('.top__banner-slider', {
  slidesPerView: 1,
  spaceBetween: 30,
  grabCursor: true,
  loop: true,
  centeredSlides: true,
  direction: 'vertical',
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
});
banner;

// Latest news
const news = new Swiper('.latest__news-slider', {
  slidesPerView: 1,
  direction: 'vertical',
  height: 400,
  spaceBetween: 0,
  grabCursor: true,
  breakpoints: {
    992: {
      slidesPerView: 2,
      direction: 'horizontal',
    },
  },
});
news;

// Agenda
const agenda = new Swiper('.agenda-slider', {
  slidesPerView: 1,
  spaceBetween: 40,
  grabCursor: true,
  breakpoints: {
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
});
agenda;



// WEBPACK FOOTER //
// ./scripts/main.js